import { useMemo } from 'react'
import usePeriod from './usePeriod'
import useAnalyticsData from './useAnalyticsData'
import useAnalyticsFormat from './useAnalyticsFormat'
import usePalette from './palette'
import { resolveKpi } from './Kpi'

/*
 * What every chart widget starts from: its period, its data for that period
 * and the one before, the headline and footer KPIs resolved, and the card's
 * status. A widget adds only its own drawing.
 */
const useAnalyticsWidget = (type, config) => {
    const period = usePeriod(type, config)
    const compare = (config.compare ?? 'previous') !== 'none'
    const data = useAnalyticsData(config.measures, period, { compare })
    const { format, locale } = useAnalyticsFormat()
    const palette = usePalette()

    const status = data.isLoading ? 'loading'
        : data.error && !data.current?.hasData ? 'error'
        : !data.current?.hasData ? 'empty'
        : null

    const headline = useMemo(() => config.headline && data.current ? resolveKpi(config.headline, data, config.measures) : null,
        [config.headline, data, config.measures])
    const kpis = useMemo(() => data.current ? (config.kpis ?? []).map(k => resolveKpi(k, data, config.measures)) : [],
        [config.kpis, data, config.measures])

    return {
        period,
        data,
        status,
        headline,
        kpis,
        format,
        locale,
        palette,
        compareLabel: config.compare === 'lastYear' ? 'analytics.compare.lastYear' : 'analytics.compare.previous',
    }
}

export default useAnalyticsWidget
